var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVoucherPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b81f40",
    d: "M23,10h1V3H0v7h1c1.103,0,2,0.898,2,2c0,1.102-0.897,2-2,2H0v7h24v-7h-1c-1.104,0-2-0.898-2-2   C21,10.898,21.896,10,23,10z M6,6c1.104,0,2,0.896,2,2c0,1.106-0.896,2-2,2S4,9.106,4,8C4,6.896,4.896,6,6,6z M4.293,15.293l9-9   l1.414,1.413l-9,9L4.293,15.293z M13,17c-1.104,0-2-0.894-2-2c0-1.104,0.896-2,2-2s2,0.896,2,2C15,16.106,14.104,17,13,17z M18,19   h-2v-2h2V19z M18,15h-2v-2h2V15z M18,11h-2V9h2V11z M18,7h-2V5h2V7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoucherPercent);
export default __webpack_public_path__ + "static/media/icon-voucher-percent.58daeb07f00e2ca49720c11a58a25a71.svg";
export { ForwardRef as ReactComponent };